import type { ThemeConfig } from "antd";
import { theme } from "antd";

import { CHROME, type Mode } from "./palette";

/**
 * 沿用 sfc-app-tstack（apps/web）的外觀：白色 header 與左側選單、#ececec 的版面底色、
 * antd 預設的藍 #1677ff，表頭 #fafafa。深色模式那邊沒有，用 antd darkAlgorithm 的對應值。
 */
const SHELL = {
  light: { accent: "#1677ff", tableHeader: "#fafafa" },
  dark: { accent: "#1668dc", tableHeader: "#1d1d1d" },
} as const;

export const antdTheme = (mode: Mode): ThemeConfig => {
  const c = CHROME[mode];
  const shell = SHELL[mode];
  return {
    algorithm: mode === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
      colorPrimary: shell.accent,
      colorBgLayout: c.plane,
      colorBgContainer: c.surface,
      colorText: c.textPrimary,
      colorTextSecondary: c.textSecondary,
      colorTextTertiary: c.muted,
      colorBorder: c.axis,
      colorBorderSecondary: c.gridline,
      colorSplit: c.gridline,
      fontFamily: `system-ui, -apple-system, "Segoe UI", "Noto Sans TC", sans-serif`,
      borderRadius: 8,
    },
    components: {
      // header 與左側工具箱是白的，內容區是灰的 —— 跟 ERP 的版面同一個結構
      Layout: {
        bodyBg: c.plane,
        headerBg: c.surface,
        siderBg: c.surface,
      },
      // 卡片只靠一條髮絲線分界，不用陰影 —— 陰影會讓每張卡看起來都在爭注意力
      Card: { colorBgContainer: c.surface, colorBorderSecondary: c.gridline },
      Table: { headerBg: shell.tableHeader, headerColor: c.textPrimary },
    },
  };
};
